import { createRouter, createWebHistory } from 'vue-router'
import store from './store'
import type { RouteItem } from './types'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: () => import('./pages/Login.vue') },
    {
      path: '/',
      name: 'admin',
      component: () => import('./layouts/AdminLayout.vue'),
      children: []
    },
    { path: '/:pathMatch(.*)*', name: 'notfound', component: { render: () => null } }
  ]
})

let routesRegistered = false

export function registerRoutes(routes: RouteItem[]) {
  routes.forEach(r => {
    router.addRoute('admin', {
      path: r.path,
      name: r.name,
      component: () => import(`./pages/${r.component}.vue`)
    })
  })
  routesRegistered = true
}

router.beforeEach((to) => {
  const token = store.state.token

  // 未登录：只允许访问登录页
  if (!token) {
    if (to.path === '/login') return true
    return '/login'
  }

  // 已登录但动态路由未注册（F5 刷新场景）
  if (!routesRegistered && store.state.routes.length) {
    registerRoutes(store.state.routes)
    return to.fullPath
  }

  // 已登录访问登录页或根路径，跳转到第一个有权限的页面
  if (to.path === '/login' || to.path === '/') {
    return store.state.routes[0]?.path ?? '/login'
  }

  // 已登录但访问了不存在的页面
  if (to.matched.length === 0 || to.name === 'notfound') {
    return store.state.routes[0]?.path ?? '/login'
  }

  return true
})

export default router
